export default __webpack_public_path__ + "static/media/IMG_2198.ad40257c.jpg";